import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RestService } from '../../shared/service/rest.service';
import { VehiclesService } from './vehicles.service';
import { map, tap } from 'rxjs/operators';
import { StoreService } from 'src/app/store/service/store.service';
import { StoreContent } from 'src/app/store/model/store-model';
import { VehicleProperties } from '../model/vehicle-properties';

@Injectable()
export class PropertiesLoaderService extends RestService {

  constructor(http: HttpClient, private vehiclesService: VehiclesService, private storeService: StoreService) {
    super(http);
    if (!this.storeService.isStorageTypeExists(VehicleProperties.getName()))
      this.storeService.addStorageType(VehicleProperties.getName(),
        new StoreContent<VehicleProperties>((properties: VehicleProperties) => properties.sideNumber));
  }

  load(): void {
    this.vehiclesService.getVehicles()
      .pipe(
        map(vehicles => vehicles.filter(vehicle => vehicle.active && vehicle.properties && Object.keys(vehicle.properties).length)),
        map(vehicles => vehicles.map(vehicle => ({ key: vehicle.sideNumber, data: { key: vehicle.sideNumber, properties: vehicle.properties } }))),
        tap(mergeData => this.storeService.merge(VehicleProperties.getName(), mergeData, true))
      )
      .subscribe();
  }

}
